<template>
  <v-card>
    <v-card-text>
      <v-card-title class="mb-3 pt-0">
        <RiskRatingPicker
          :given-rating="selectedRating"
          :multiple="false"
          @change="handleChangeRating"
          :params="params"
          :hide-maritime-subs="true"
        ></RiskRatingPicker>
      </v-card-title>
      <v-card-subtitle>
        {{ description }}
      </v-card-subtitle>

      <div class="definition-card-container">
        <v-card
          v-for="level in levels"
          :key="level.value"
          width="230"
          class="pull-left mr-2 definition-card"
        >
          <v-card-title class="text-h5 mb-3">
            <div class="pull-left" :style="getCardTitleStyle(level)"></div>
            <div class="pull-left ml-2">{{ level.name.toUpperCase() }}</div>
            <div class="clearfix"></div>
          </v-card-title>
          <v-card-subtitle class="definition-card-subtitle">
            <p>{{ level.highlight }}</p>
            <ul>
              <li v-for="(detail, index) in level.details" :key="index">
                {{ detail }}
              </li>
            </ul>
          </v-card-subtitle>
        </v-card>
        <div class="clearfix"></div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import lodashGet from "lodash/get";
import lodashOrderBy from "lodash/orderBy";
import lodashFind from "lodash/find";

import {
  RISK_LEVELS,
  RISK_RATING_DESCRIPTIONS,
  RISK_RATING_PRIMARIES,
} from "@/common/constants/controlRisks/risks";

export default {
  name: "RiskRatingDefinitions",
  components: {
    RiskRatingPicker: () =>
      import("@/components/controlRisks/risks/RiskRatingPicker"),
  },
  props: {
    ratingId: {
      type: String,
    },
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    const ratingId = this.ratingId
      ? this.ratingId
      : RISK_RATING_PRIMARIES.political;
    this.selectedRating = lodashFind(RISK_RATING_DESCRIPTIONS, {
      id: ratingId,
    });
  },
  data() {
    return {
      showPopup: false,
      selectedId: 1,
      selectedRating: null,
    };
  },
  computed: {
    ratings() {
      return lodashOrderBy(RISK_RATING_DESCRIPTIONS, ["id"]);
    },
    id() {
      if (lodashGet(this.selectedRating, "id")) {
        return this.selectedRating.id;
      }
      return null;
    },
    name() {
      if (lodashGet(this.selectedRating, "name")) {
        return this.selectedRating.name;
      }
      return null;
    },
    description() {
      if (lodashGet(this.selectedRating, "description")) {
        return this.selectedRating.description;
      }
      return null;
    },
    levels() {
      if (lodashGet(this.selectedRating, "levels")) {
        return lodashOrderBy(this.selectedRating.levels, ["value"]);
      }
      return null;
    },
  },
  methods: {
    getDetails(level) {
      let details = [];
      if (level && level.details) {
        details = level.details.split(".");
      }
      return details;
    },
    getBgColor(value) {
      if (value) {
        const level = lodashFind(RISK_LEVELS, { value: value });
        if (lodashGet(level, "bgColor")) {
          return level.bgColor;
        }
      }
      return null;
    },
    getCardTitleStyle(level) {
      if (level && level.value) {
        const bgColor = this.getBgColor(level.value);
        return {
          "background-color": bgColor,
          width: "30px",
          height: "30px",
          "border-radius": "15px",
        };
      }
      return null;
    },
    handleChangeRating(rating) {
      if (rating && rating.id) {
        this.selectedRating = lodashFind(RISK_RATING_DESCRIPTIONS, {
          id: rating.id,
        });
      }
    },
  },
  watch: {
    ratingId() {
      const ratingId = this.ratingId ? this.ratingId : 1;
      this.selectedRating = lodashFind(RISK_RATING_DESCRIPTIONS, {
        id: ratingId,
      });
    },
  },
};
</script>

<style>
.rating-list .v-select__selection {
  font-size: 24px !important;
  line-height: 28px !important;
}
.rating-list .v-text-field__details {
  display: none !important;
}
</style>

<style scoped>
.definition-card {
  height: 500px;
  overflow-y: auto;
}
.definition-card-subtitle {
  font-size: 12px;
}
.definition-card-container {
  height: 500px;
}
</style>
